// extracted by mini-css-extract-plugin
module.exports = {"head":"newsoptions_head__1JTl5","active":"newsoptions_active__3vQk-"};